import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  ...requestCases('SURVEY_FINISHED', { success: dataAs('finished_survey_data') }),
  ...requestCases('GET_OPPORTUNITY', { success: dataAs('opportunity_list') }),
});
